const _ = require('lodash');
import { UtilityService } from '../utility.service';
import { DataService } from './data.service';

/**
 * This class handles display language.
 */
export class LanguageDeciderService {
	private utilityService: UtilityService;
	private isFallbackUsed = false;
	private fallBackLanguages = ['languages', 'en', 'de', 'fr', 'es'];
	constructor(utilityService) {
		this.utilityService = utilityService;
	}

	get fallbackUsed() {
		return this.isFallbackUsed;
	}

	resetFallbackUsed() {
		this.isFallbackUsed = false;
	}

	getInterfaceLanguage() {
		return (
			this.getLanguageFromScriptAttribute() ||
			this.getBrowserLanguage()
		);
	}

	getLanguageFromScriptAttribute() {
		if (window.usercentrics && window.usercentrics.language) {
			// try to get language from form script language='something'
			this.utilityService.developmentLog(
				'getting language from script attribute',
				window.usercentrics.language
			);
			return { from: 'script', language: window.usercentrics.language };
		}
		return null;
	}

	getBrowserLanguage() {
		const userLang =
			window.navigator.language || window.navigator['userLanguage'];
		this.utilityService.developmentLog(
			'getting language from browser',
			userLang.split('-')[0]
		);
		return { from: 'browser', language: userLang.split('-')[0].toLowerCase() };
	}

	getFallbackLanguage(prevLang) {
		this.utilityService.developmentLog('getting fallback language');
		if (this.isFallbackUsed) {
			if (this.fallBackLanguages.indexOf(prevLang) === -1) {
				return this.fallBackLanguages[0];
			}
			if (
				this.fallBackLanguages.indexOf(prevLang) !==
				this.fallBackLanguages.length - 1
			) {
				return this.fallBackLanguages[
					this.fallBackLanguages.indexOf(prevLang) + 1
				];
			}
			// expected a return value
			return null;
		}
		this.isFallbackUsed = true;
		if (this.fallBackLanguages.indexOf(prevLang) > 0) {
			prevLang = null;
		}
		return this.getFallbackLanguage(prevLang);
	}

	getFirstAvailableLanguage(languagesAvailable) {
		this.utilityService.developmentLog(
			'getting first available language from ',
			languagesAvailable
		);
		if (languagesAvailable.length) {
			return languagesAvailable[0];
		}
		// expected a return value
		return null;
	}
}
